
<template lang="html">
  <div class="group-result-main">
    <div v-if="!isIOS" class="group-result-main-andriod">
      <div class="group-result-main-andriod-qrcode">
        <img :src="qrCode" alt="">
        <p>长按扫描二维码关注公众号</p>
        <p>即可学习课程</p>
      </div>
      <div class="group-result-main-andriod-ctx">
        <img src="../assets/images/groupResultctx.png" alt="">
      </div>
    </div>
    <div class="group-result-main-ios" v-else>
      <h3>陪伴学习，让你变得更好</h3>
      <p>请务必关注微课微信公众号</p>
      <p>确保能接受到拼课相关信息</p>
      <section :style="{backgroundImage:`url(${getWXSub})`}" class="group-result-main-ios-sign">
        wpsjingpinke
      </section>
    </div>

    <div v-if="isIOS" class="group-result-main-button" @click="click">
      公众号如何添加？点这里
      <img src="../assets/images/result-icon-arrow.png" alt="" class="group-result-main-button-arrow" :class="[open ? 'on' : '']">
    </div>
    <div class="group-result-main-image" v-show="open">
      <img src="//cdn.iciba.com/www/eduwx/sign-up-result-guide_steps.png" class="img-w" alt="">
    </div>
  </div>
</template>

<script>
import groupImgUrlData from '../assets/images/sign-up-result-group_guide_steps.png'
import getWXData from '../assets/images/get_wx.png'
import getWXSubData from '../assets/images/get_wx_sub.png'

export default {
  name: 'GroupResultMain',

  props: ['qrCode'],

  data () {
    return {
      open: false,
      isIOS: false,
      groupImgUrl: groupImgUrlData,
      getWX: getWXData,
      getWXSub: getWXSubData
    }
  },

  methods: {
    click () {
      this.open = !this.open
    }
  },

  created () {
    this.isIOS = /iphone os/i.test(navigator.userAgent)
    console.log(this.isIOS)
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.group-result-main {
  position: relative;
  text-align: center;
  &-text {
    position: absolute;
    left: use(200);
    top: use(320);
    width: use(350);
    height: use(70);
    font-size: use(48);
    background-color: #fff;
    color: #000;
  }
  &-andriod {
    text-align: center;
    padding-top: rem(185);
    &-qrcode {
      margin-bottom: rem(120);
      > img {
        width: rem(300);
        margin-bottom: rem(32);
      }
      > p {
        font-size: rem(28);
        color: #999999;
        line-height: 1.5;
      }
    }
    &-ctx {
      > img {
        width: rem(413);
      }
    }
  }
  &-ios {

    h3 {
      color: #F48F00;
      font-size: rem(38);
      text-align: center;
      margin-top: rem(60);
      margin-bottom: rem(32);
    }

    p {
      color: #999999;
      font-size: rem(28);
      text-align: center;
      margin-bottom: rem(10);
    }

    section {
      height: rem(132);
      width: rem(400);
      margin: rem(80) auto;
      margin-bottom: 0;
      background-size: 100%;
      color:#F4484C;
      font-size: rem(48);
      font-weight: bold;
      text-align: center;
      line-height: rem(132);
    }
  }

  &-qr {
    &-bg {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      height: 100%;
      width: 100%;
      opacity: 0;
    }

    position: absolute;
    left: 0; right: 0;
    top: rem(230);
    margin: 0 auto;
    height: rem(270);
    width: rem(270);
  }

  &-tip {
    display: block;
    width: use(418);
    margin: use(60) auto 0;
  }
  &-button {
    margin: use(90) auto 0;
    width: use(390);
    @include height(60);
    background-color: #FFEFD7;
    border-radius: use(30);
    color: #F48F00;
    font-size: use(26);
    &-arrow {
      display: inline-block;
      @include square(18, 10);
      margin-left: use(10);
      @include relative(-4);
      @include rotate();
      transition: .3s;
      &.on {
        @include rotate(180deg);
      }
    }
  }
  &-image {
    width: use(489);
    margin: use(40) auto 0;
  }
}
</style>
